import React, { Component } from 'react'
import './index.less'
import { setHeader } from '@/util/set-header'
import { Calendar, ActionSheet, Toast } from 'antd-mobile'
import { fetchStoreDetail } from '@/api/book'
// import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { connect } from 'react-redux'

import {
  SET_ID,
  SET_ADDRESS,
  SET_NAME,
  SET_ARRIVAL_INFO,
  SET_ROOM_INFO,
  SET_RESERVE_REMARK,
  SET_START_DAY,
  SET_END_DAY,
  SET_DAYS,
  SET_TOTALPRICE
} from '@/action-types/book'

const extra: any = {
  '2017/07/15': { info: 'Disable', disable: true },
}

const now = new Date()

interface Props {
  location: H.Location
  history: H.History
}

const mapStateToProps = () => ({})

const mapDispatchToProps = (dispatch: any) => {
  return {
    setIdAction: (id: any) =>
      dispatch({ type: SET_ID, id }),
    setAddressAction: (address: any) =>
      dispatch({ type: SET_ADDRESS, address }),
    setNameAction: (name: any) =>
      dispatch({ type: SET_NAME, name }),
    setArrivalAction: (arrival_info: any) =>
      dispatch({ type: SET_ARRIVAL_INFO, arrival_info }),
    setRemarkAction: (reserve_remark: any) =>
      dispatch({ type: SET_RESERVE_REMARK, reserve_remark }),
    setStartDayAction: (start_day: any) =>
      dispatch({ type: SET_START_DAY, start_day }),
    setEndDayAction: (end_day: any) =>
      dispatch({ type: SET_END_DAY, end_day }),
    setDaysAction: (days: any) =>
      dispatch({ type: SET_DAYS, days }),
    setTotalPriceAction: (totalPrice: any) =>
      dispatch({ type: SET_TOTALPRICE, totalPrice }),
    setRoomInfoAction: (room_info: any) =>
      dispatch({ type: SET_ROOM_INFO, room_info })
  }
}

@(connect(
  mapStateToProps,
  mapDispatchToProps,
) as any)
export default class Booking extends Component<any, any> {
  roomInfo: any = []

  state = {
    store: {
      id: '0',
      name: '',
    },
    show: false,
    config: {},
    startDate: '',
    endDate: '',
    days: '1',
    defaultStartTime: new Date(+now),
    defaultEndTime: new Date(+now + 61920000),
    selectRoom: '选择入住房型',
    selectPrice: '',
    totalPrice: '0.00',
    totalDays: 1,
    thirtiethPrice: 0,
    offerPrice: '0',
    unitPrice: 0,
    room_info: {},
  }

  UNSAFE_componentWillMount() {
    setHeader({ title: '预订', leftClick: this.closePage.bind(this) })
  }

  // 关闭当前缴费页
  closePage() {
    if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
  }

  // 选择日期
  onDateSelect = () => {
    this.setState({
      show: true,
      config: {
        defaultValue: [this.state.defaultStartTime, this.state.defaultEndTime],
      },
    })
  }

  // 确认日期
  onConfirm = (startTime: any, endTime: any) => {
    this.setState(
      {
        show: false,
        startTime,
        endTime,
        startDate: this.date(startTime),
        endDate: this.date(endTime),
        days: this.day(startTime, endTime),
        defaultStartTime: startTime,
        defaultEndTime: endTime,
        totalDays: this.day(startTime, endTime),
      },
      () => {
        this.getPrice()
      },
    )
  }

  // 日期换成想要的展示
  date(startTime: any) {
    const newDate =
      startTime.getFullYear() +
      '-' +
      (startTime.getMonth() + 1) +
      '-' +
      startTime.getDate()
    return newDate
  }

  // 计算两个日期间的天数
  day(startTime: any, endTime: any) {
    var diff = endTime.getTime() - startTime.getTime() //时间差的毫秒数

    //计算出相差天数
    var days = Math.floor(diff / (24 * 3600 * 1000))
    return days
  }

  // 计算总价钱
  getPrice() {
    const { setStartDayAction, setEndDayAction, setDaysAction, setTotalPriceAction, setRoomInfoAction } = this.props

    if (this.state.totalDays === 30) {
      this.setState({
        totalPrice: this.state.thirtiethPrice,
      }, () => {
        setTotalPriceAction(this.state.totalPrice)
      })
    } else if (this.state.totalDays > 30) {
      this.setState({
        totalPrice: (this.state.thirtiethPrice / 30) * this.state.totalDays,
        offerPrice:
          this.state.unitPrice * this.state.totalDays -
          (this.state.thirtiethPrice / 30) * this.state.totalDays,
      }, () => {
        setTotalPriceAction(this.state.totalPrice)
      })
    } else {
      this.setState({
        totalPrice: this.state.unitPrice * this.state.totalDays,
      }, () => {
        setTotalPriceAction(this.state.totalPrice)
      })
    }
    setStartDayAction(this.date(this.state.defaultStartTime))
    setEndDayAction(this.date(this.state.defaultEndTime))
    setDaysAction(this.state.days)
    setRoomInfoAction(this.state.room_info)
  }

  getDateExtra = (date: any) => extra[+date]

  componentDidMount() {
    const { location } = this.props
    this.setState({
      startDate: this.date(new Date(+now)),
      endDate: this.date(new Date(+now + 61920000)),
    })
    const params = new URLSearchParams(location.search)
    const id = params.get('id')
    const name = params.get('name')
    if (id) {
      this.getStoreDetail(id)
      this.setState({ store: { id, name } })
    }
  }

  // 获取房间信息
  getStoreDetail = async (store_id: string) => {
    const data = await fetchStoreDetail(store_id)
    this.roomInfo = data.data.room_info
    const { setIdAction, setAddressAction, setNameAction, setArrivalAction, setRemarkAction } = this.props
    setIdAction(data.data.id)
    setAddressAction(data.data.address)
    setNameAction(data.data.name)
    setArrivalAction(data.data.arrival_info)
    setRemarkAction(data.data.reserve_remark)
  }

  // 选择房间
  showRoomActionSheet = () => {
    if (this.state.store.id === '0') {
      Toast.show('请选择门店')
      return
    }

    if (this.roomInfo.length === 0) {
      Toast.show('当前无入住房型')
      return
    }

    const dataList: any = this.roomInfo.map((info: any) => (
      <div className="selectRoom">
        <span>{info.name}</span>
        <span className="room">{info.day_price}/天/床</span>
      </div>
    ))

    ActionSheet.showActionSheetWithOptions(
      {
        options: dataList,
        cancelButtonIndex: dataList.length,
        message: '房型选择',
        maskClosable: true,
      },
      buttonIndex => {
        if (buttonIndex < dataList.length) {
          this.setState(
            {
              selectRoom: '房型：' + this.roomInfo[buttonIndex].name,
              selectPrice:
                parseFloat(this.roomInfo[buttonIndex].day_price).toFixed(2) +
                '元/天/床',
              thirtiethPrice: this.roomInfo[buttonIndex].day_30_price,
              unitPrice: parseFloat(
                this.roomInfo[buttonIndex].day_price,
              ).toFixed(2),
              room_info: this.roomInfo[buttonIndex]
            },
            () => {
              this.getPrice()
            },
          )
        }
      },
    )
  }

  // 填写预订信息
  addBook = () => {
    const { history } = this.props
    if (this.state.store.id === '0') {
      Toast.show('请选择门店')
      return
    }
    if (this.state.unitPrice === 0) {
      Toast.show('请选择房间')
      return
    }
    if (parseFloat(this.state.totalPrice) === 0) {
      Toast.show('入住的时间不足一晚')
      return
    }

    history.push(`/book/write-info`)
  }

  // 关闭日历
  onCancel = () => {
    this.setState({
      show: false
    })
  }

  render() {
    const { location, history } = this.props
    const { store } = this.state
    return (
      <div className="book-body">
        <div
          className="address"
          onClick={() => history.push(`/book/select-store${location.search}`)}
        >
          <div>
            <div className="top">公寓/酒店</div>
            <div className="bottom">
              {store.name ? store.name : '选择入住公寓/酒店'}
            </div>
          </div>
          <img className="img" src="/public/assets/img/ic_more.png" alt="" />
        </div>
        <div className="timeBackground">
          <div className="time" onClick={this.onDateSelect}>
            <div>
              <div className="top">入住</div>
              <div className="bottom">{this.state.startDate}</div>
            </div>
            <div className="info">
              <div className="top">离店</div>
              <div className="bottom">{this.state.endDate}</div>
            </div>
          </div>
          <div className="line"></div>
          <div className="day">{this.state.days}晚</div>
        </div>
        <div className="address" onClick={this.showRoomActionSheet}>
          <div className="bottom">{this.state.selectRoom}</div>
          <span className="info">
            <span className="selectPrice">{this.state.selectPrice}</span>
            <img className="img" src="/public/assets/img/ic_more.png" alt="" />
          </span>
        </div>
        <div className="price">
          <span>
            <span className="left">总价：</span>
            <span className="right">
              {parseFloat(this.state.totalPrice).toFixed(2)}元
            </span>
          </span>
          {this.state.totalDays <= 30 ||
            parseFloat(this.state.totalPrice) === 0 ? (
              <span className="offer">入住超过30天可享受优惠价</span>
            ) : (
              <span>
                <span className="offerLeft">已优惠</span>
                <span className="offerRight">
                  {parseFloat(this.state.offerPrice).toFixed(2)}元
              </span>
              </span>
            )}
        </div>
        <div className="button" onClick={this.addBook}>
          <div className="background">
            <div className="title">立即预订</div>
          </div>
        </div>
        <Calendar
          {...this.state.config}
          visible={this.state.show}
          onCancel={this.onCancel}
          onConfirm={this.onConfirm}
          getDateExtra={this.getDateExtra}
          defaultDate={now}
          minDate={new Date(+now)}
          maxDate={new Date(+now + 31536000000)}
        />
      </div>
    )
  }
}
